import { useEffect, useState } from "react";
import { PhonePrefix } from "../../pages/Admin/Members/PersonalInfo/personalInfo";
import { Api } from "../api";
import { Individual, MemberDetails } from "../api/types/Members";

export const makeUndefined = (thing: any) => {
  if (!thing) return undefined;
  try {
    Object.keys(thing).map(key => {
      if (typeof thing[key] === "string" || Array.isArray(thing[key])) {
        thing[key] = thing[key].length ? thing[key] : undefined;
        if (Array.isArray(thing[key])) {
          thing[key].map((item: any) => makeUndefined(item));
        }
      } else if (typeof thing[key] === "object") {
        thing[key] = makeUndefined(thing[key]);
      }
    });
  } catch (error) {
    if (error instanceof Error) {
      //ignore path error on imgs
      if (error.message === '"path" is read-only') return thing;

      console.error("MakeUndefined", error);
    }
  }
  return thing;
};

const makeDate = (dateStr: string) => {
  const index = dateStr.indexOf("T");
  if (index !== -1) {
    dateStr = dateStr.substr(0, index);
  }
  return new Date(dateStr + "T00:00");
};

const updateIndividual = (individual: Individual) => {
  if (individual.birthDate && typeof individual.birthDate === "string")
    individual.birthDate = makeDate(individual.birthDate);
  if (individual.hireDate && typeof individual.hireDate === "string")
    individual.hireDate = makeDate(individual.hireDate);
  if (individual.deceasedDate && typeof individual.deceasedDate === "string")
    individual.deceasedDate = makeDate(individual.deceasedDate);
  if (individual.phone)
    individual.phone = individual.phone.replace(PhonePrefix, "");
  if (individual.phones) {
    individual.phones.map(phone => {
      phone.phone = phone.phone.replace(PhonePrefix, "");
    });
  }
  return individual;
};

export function useMemberDetails(memberId = "") {
  const [memberDetails, setMemberDetails] = useState<MemberDetails>();
  useEffect(() => {
    if (memberId === "") {
      return;
    }
    const getMemberDetails = async () => {
      try {
        const response = await Api.members
          .getMemberDetails(memberId)
          .catch(error => {
            console.error(error);
          });
        if (response) {
          //convert dates from strings
          updateIndividual(response.data.member);
          if (response.data.spouse) {
            updateIndividual(response.data.spouse);
          }
          if (response.data.children) {
            response.data.children.map(child => {
              updateIndividual(child);
            });
          }
          if (response.data.pets) {
            response.data.pets.map(child => {
              updateIndividual(child);
            });
          }
          if (response.data.employmentInfo) {
            const employmentInfo = response.data.employmentInfo;
            if (
              employmentInfo.driversLicenseExpiration &&
              typeof employmentInfo.driversLicenseExpiration === "string"
            ) {
              employmentInfo.driversLicenseExpiration = makeDate(
                employmentInfo.driversLicenseExpiration
              );
            }
            if (
              employmentInfo.workVisaExpirationDate &&
              typeof employmentInfo.workVisaExpirationDate === "string"
            ) {
              employmentInfo.workVisaExpirationDate = makeDate(
                employmentInfo.workVisaExpirationDate
              );
            }
          }
          makeUndefined(response.data);
          setMemberDetails(response.data);
        }
      } catch (error) {
        console.error("Member Details:", error);
      }
    };
    getMemberDetails();
  }, [memberId]);
  return memberDetails;
}
